import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import GreidiApp from '../greidi-app.jsx';
import ErrorBoundary from './components/ui/ErrorBoundary';
import DesktopLanding from './components/layout/DesktopLanding';
import { reportWebVitals } from './utils/performance';
import { initSentry } from './utils/sentry';

initSentry();

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const audience = import.meta.env.VITE_AUTH0_AUDIENCE;
const redirectUri = import.meta.env.VITE_AUTH0_REDIRECT_URI || window.location.origin;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Auth0Provider
          domain={domain}
          clientId={clientId}
          authorizationParams={{
            redirect_uri: redirectUri,
            audience: audience,
            scope: "openid profile email",
          }}
          cacheLocation="localstorage"
        >
          <DesktopLanding>
            <GreidiApp />
          </DesktopLanding>
        </Auth0Provider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// Web Vitals: always populates window.__PERF__, logs to console in dev only
reportWebVitals(import.meta.env.DEV
  ? ({ name, value, rating }) => console.log(`[Perf] ${name}: ${value} (${rating})`)
  : undefined
);
